import SpecialOfferAdd from './Add.vue'
import SpecialOfferEdit from './Edit.vue'

export default [
  {
    path: 'add',
    name: 'SpecialOfferAdd',
    props: true,
    component: SpecialOfferAdd
  },
  {
    path: 'edit',
    name: 'SpecialOfferEdit',
    props: true,
    component: SpecialOfferEdit
  }
]
